// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/fab/dist/mdc.fab.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdc-fab {
    --mdc-theme-secondary: #004ba0;
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background-color: #1976d2;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/shared/css/material-fab.css"],"names":[],"mappings":"AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd","sourcesContent":["@import \"../../../node_modules/@material/fab/dist/mdc.fab.min.css\";\n\n.mdc-fab {\n    --mdc-theme-secondary: #004ba0;\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n    background-color: #1976d2;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
